/**
 * Mask an email for UI display only (OTP header).
 * Keeps the full domain; masks the local part as first-char + `***` (or `*` + `***` for single-char local).
 */
export function maskEmailForDisplay(email: string): string {
  const trimmed = email.trim()
  const at = trimmed.lastIndexOf('@')
  if (at <= 0 || at === trimmed.length - 1) return '***'

  const local = trimmed.slice(0, at)
  const domain = trimmed.slice(at + 1)
  const visible = local.length === 1 ? '*' : local[0]
  return `${visible}***@${domain}`
}
